import React, { useEffect, useState } from 'react'
import {BsCheckSquareFill,BsCheckSquare} from 'react-icons/bs';
import Renderif from './renderif';
import { Service } from '../services/api'

export default function CheckBox({...props}) {

    
    const [state, setState] = useState({
        active:props.checked
    })

    useEffect(()=>{
        if(props.checked !== undefined){
            console.log(props.checked)
            setState({...state, active:props.checked})
        }

    },[props.checked])

    const onClick  = async() => {
        // titulo del item?.agreementTitle

        if(!props.checked){
            let body = {
                id:props.id,
                isDone: true
            }
            let update = await Service('PUT', 'Agreement/done', body);

            setState({...state, active:!state.active})
            // props.onChange(!state.active)
        }
        else{
            console.log("des");
            let body = {
                id:props.id,
                isDone: false
            }
            let update = await Service('PUT', 'Agreement/done', body);

            setState({...state, active:!state.active})
        }
      
    }
  return (
    <div className='d-flex align-items-center cursor-pointer w-content prevent-select' onClick={()=>{onClick()}}>

  
        <div className='bv-icon my-1 me-2'>
            <Renderif isTrue={state.active}>
                <BsCheckSquareFill color='#0972CE' />
            </Renderif>

            <Renderif isTrue={!state.active}>
                <BsCheckSquare color='#CCC' />
            </Renderif>
        </div>
        <div className='f-12 text-gray'>{props.text}</div>
    </div>

  )
}
